export enum SQLIndex {
  Unknown = 0,
  CompanyList,
  CompanyListEx,
  ReferenceNo,
  POL,
  POLCode,
  POD,
  PODCode,
  VSLoFLT,
  FinalDestination,
  SalesMan,                   // 10
  HBLoHAWB,

  /// <summary>
  /// t_companybroker
  /// searchText = f_companyid, formPara2 = "IncludeInactive"|""
  /// </summary>
  CompanyBroker,
  WareShipItems,
  AmsPortList,
  AmsSCAC,
  AmsVessel,
  WareCenterNo,
  WareLocation,
  //<pt200914: Find by Name이므로 이름을 변경함. (아마도 이것을 사용할 일이 없을 듯)
  //UserList,
  UserByName,
  //pt200914>
  OceanPOL,                   // 20
  OceanPOD,
  OceanFinalDestination,
  AirPOL,
  AirPOD,
  AirFinalDestination,
  CustSvcRep,
  LiftingSCAC,
  LiftingAgent,
  CompanyGroup,
  Carrier,                    // 30
  Airline,
  CompanyContact,
  LOTnoALL,
  LOTnoOI,
  LOTnoOE,
  Bank,
  GLNo,

  /// <summary>
  /// formPara = Dept, formPara2 = ChgType
  /// </summary>
  BillingCode,
  CompanyListAgntOnly,
  CompanyListNotAgnt,         // 40
  SubCode,
  CompanyListConLoc,
  Vessel,
  SCAC,
  AirPort,
  AirPortCode, //sjcho 20210604 - Add AirPortCode
  Broker,
  State,
  Country,
  SchDb,                      // 50
  Airline_Ex,                 
  CompanyListAgntParial,
  GLNoPayrollAcctSalaries,
  GLNoPayrollTax,        
  ConfirmCrDb,
  PrepaidExpenseList,
  DepreciationList,
  AmortizationList,
  //<pt200914: Find by ID이므로 이름을 변경함>
  //UserEMailList          //[191110215]
  UserByID,
  //pt200914>
  WareRcvItems,       // <pt201028: Warehouse/Receiving의 Item을 ListView Lokkup에서 Control Lookup으로 변경함>
  GLNoPrepaidExpense, // sjcho 20210427 - Prepaid Expense View의 기존 Combo 동작을 Lookup으로 변경하기 위해 추가
  BillingCodeCustomized,   // <chuck date="2021-12-03" desc="Desc/Local Desc를 구분해서 사용할 수 있게 분리함." />
  BillingCodeWR,
  BillingCodeWS,
  
  //mskim 220614 JobListView를 사용하는 Lookup 기능을 Lookup control을 사용하도록 변경
  OiMblItems,
  OeMblItems,
  AiMblItems,
  AiHblItems,
  AeMblItems,
  WhReceiptsItems,
  OeBookingItems,
  OeQuotItems,
  OiHblItems,
  JournalLedgerItems,
  //mskim End
  CopyInvRefNos, // <chuck date="2023-02-03" tag="CopyInvoice" desc="Copy Invoice에서 사용하는 Lookup 추가">
  CopyInvFromAcct,
  MoveType,
  BillingCodePayroll,      // 2024.07.02 Add
  CompanyListFirms,        // 2025.05.21 Add
  CompanyListNotAgntFirms, // 2025.05.21 Add
  GLNoSalesCost,          //2025.10.17

  GLNoPrepayment,  // 3.3, SUNTEK ONLY 사용 
  PrepaymentList, // 3.3, SUNTEK ONLY 사용 
  AdvanceSalesList, //2026.10.07 - Suntek Only 
  GLNoAdvanceSales, //2026.10.07 - Suntek Only

  ListViewLookup = 1000,
  OiMblList,
  OeMblList,
  AiMblList,
  AiHblList,
  AeMblList,
  WhReceiptsList,
  WhReceiptsPanPList,
  OeBookingList,           // 2020.09.21 Add
  OeQuotList,
  OiHblList,               // 2020.11.12 Add
  JournalLedgerList,       // 2020.12.04 Add
  Department,              // 2022.08.23 Add jhchoi
  
  // jhlee.250905.Issue#2734  - Ocean Quotation List > OI Quotation List와 OE Quotation List로 분리, Air Quotation List > AI Quotation List와 AE Quotation List로 분리
  OiQuotationList,
  OeQuotationList,
  AiQuotationList,
  AeQuotationList,
  // jhlee End
}

export enum FmsComboType {
  //#region No db access
  /// <summary>
  /// List of TextValue
  /// Text = FullName
  /// Value = ShortName
  /// IntValue = Value to save
  /// </summary>
  AcctCodeType = "AcctCodeType",

  /// <summary>
  /// List of TextValue
  /// Text = Curr
  /// Value = Curr
  /// </summary>
  Currency12 = "Currency12",

  /// <summary>
  /// List of TextValue
  /// Text = Display
  /// IntValue = Value
  /// </summary>
  Obl = "Obl",

  /// <summary>
  /// List of String (Incoterm)
  /// </summary>
  Incoterms = "Incoterms",

  /// <summary>
  /// List of String (PUnit)
  /// </summary>
  PackageUnit = "PackageUnit",
  //#endregion

  //#region Class
  /// <summary>
  /// LookupEdit with Display(CodeBank.BankName), Value(CodeBank.Id)
  /// </summary>
  Bank = "Bank",

  /// <summary>
  /// LookupEdit with Display(CompanyBroker.BrokerName), Value(CompanyB roker.BrokerId)
  /// </summary>
  Broker = "Broker",

  /// <summary>
  /// LookupEdit with Display(CompanyContact.Name), Value(CompanyCon tact.Id)
  /// </summary>
  CompanyContact = "CompanyContact",

  /// <summary>
  /// LookupEdit with Display(CreditCard.AcctSName), Value(CreditCard.Id)
  /// </summary>
  CreditCard = "CreditCard",

  /// <summary>
  /// LookupEdit with Display(CodeEPay.Name), Value(CodeEPay.Id)
  /// </summary>
  CodeEPay = "CodeEPay",

  /// <summary>
  /// LookupEdit with Display(CodeState.CodeStateText), Value(CodeState.CodeStateText)
  /// </summary>
  State = "State",

  /// <summary>
  /// LookupEdit with Display(SecurityGroup.Name), Value(SecurityGroup.Id)
  /// </summary>
  SecurityGroup = "SecurityGroup",

  /// <summary>
  /// LookupEdit with Display(CodeANTitle.AnTitle), Value(CodeANTitle.AnTitle)
  /// </summary>
  ANTitle = "ANTitle",
  //#endregion

  //#region TextValue
  /// <summary>
  /// List of TextValue
  /// Text = t_codecountry.f_countryname
  /// Value = t_codecountry.f_isocode
  /// </summary>
  Country = "Country",

  /// <summary>
  /// List of TextValue
  /// Value = Display, Value
  /// </summary>
  IsoCountry = "ISOCountry",

  /// <summary>
  /// List of TextValue
  /// Text = t_ncodecurrency.f_code
  /// JobCurrency와 공유되기 때문에 Text 하나만 읽어옴에도 String이 아닌 TextValue Type을 사용
  /// </summary>
  Currency = "Currency",

  /// <summary>
  /// List of TextValue
  /// Text = Hbl.f_currency1 or Mbl.f_cur1 or Invo.f_cur
  /// Value = Hbl.f_currency2 or Mbl.f_cur2
  /// </summary>
  JobCurrency = "JobCurrency",

  /// <summary>
  /// List of TextValue
  /// Text = t_codeline.f_code + f_localdesc
  /// Value = t_codeline.f_code
  /// </summary>
  Lines = "Lines",

  /// <summary>
  /// List of TextValue
  /// Text = t_codedata.f_name or t_company.f_sname(join t_codedata.f_comid1~5)
  /// IntValue = -1 or t_codedata.f_comid1~5
  /// </summary>
  MultiName = "MultiName",

  /// <summary>
  /// List of TextValue
  /// Text = t_web_center.f_center_no
  /// Value = t_web_center.f_center_type
  /// </summary>
  WebCenter = "WebCenter",

  Quarter = "Quarter",

  /// <summary>
  /// List of TextValue
  /// Text = t_codelic.f_code
  /// Value = t_codelic.description
  /// </summary>
  ExportLic = "ExportLic",

  /// <summary>
  /// List of TextValue
  /// Text = t_codeeic.f_code
  /// Value = t_codeeic.description
  /// IntValue = RowNum - 1 (0, 1, 2 ...)
  /// </summary>
  ExportInfo = "ExportInfo",

  /// <summary>
  /// List of TextValue
  /// Text = t_odtc_usmlcat.f_code
  /// Value = t_odtc_usmlcat.description
  /// IntValue = RowNum - 1 (0, 1, 2 ...)
  /// </summary>
  ODTCCategory = "ODTCCategory",

  /// <summary>
  /// List of TextValue
  /// Text = t_odtc_uom.f_code
  /// Value = t_odtc_uom.description
  /// IntValue = RowNum - 1 (0, 1, 2 ...)
  /// </summary>
  ODTCUnitOfMeasure = "ODTCUnitOfMeasure",

  /// <summary>
  /// List of TextValue
  /// Text = t_securitytask.f_desc
  /// IntValue = t_securitytask.f_id
  /// </summary>
  SecurityControl = "SecurityControl",

  /// <summary>
  /// List of TextValue
  /// Text = T_CODEGLNO.F_GLNO - T_CODEGLNO.F_GLDESCRIPTION
  /// Value = T_CODEGLNO.F_GLDESCRIPTION
  /// IntValue = T_CODEGLNO.F_GLNO
  /// </summary>
  BankAcctCode = "BankAcctCode",
  //#endregion

  //#region String
  /// <summary>
  /// List of String (t_codebltype.f_mbltype)
  /// </summary>
  BlType = "BlType",

  /// <summary>
  /// List of String (t_codebranch.f_branch)
  /// </summary>
  Branch = "Branch",

  /// <summary>
  /// List of String (t_codecontainer.f_type)
  /// </summary>
  CntrType = "CntrType",

  /// <summary>
  /// List of String (t_codegroup.f_groupid)
  /// </summary>
  CodeGroup = "CodeGroup",

  /// <summary>
  /// List of String (t_codecommodity.f_description)
  /// </summary>
  Commodity = "Commodity",

  /// <summary>
  /// List of String (t_com panygroup.f_groupid)
  /// </summary>
  CompanyGroup = "CompanyGroup",

  /// <summary>
  /// List of String (Text = t_user.f_userid or t_codesman.f_smanid)
  /// </summary>
  CustSvcRep = "CustSvcRep",

  /// <summary>
  /// List of String (t_codemovetype.f_movetype)
  /// </summary>
  MoveType = "MoveType",

  /// <summary>
  /// List of String (t_codesman.f_smanid)
  /// </summary>
  Salesperson = "Salesperson",

  /// <summary>
  /// List of String (t_codestate.f_code)
  /// </summary>
  StateCode = "StateC",

  /// <summary>
  /// List of String (t_user.f_userid)
  /// </summary>
  User = "User",

  /// <summary>
  /// List of string (t_web_center.f_center_no)
  /// </summary>
  EdiWebCenter = "EdiWebCenter",

  /// <summary>
  /// List of String (t_codeothertype.f_type)
  /// </summary>
  Category = "Category",

  /// <summary>
  /// List of String (t_containergroup.f_type)
  /// </summary>
  CntrGroup = "CntrGroup",
  //#endregion

  /// <summary>
  /// List of String (t_department.f_name)
  /// </summary>
  Department = "Department",
}

export class  ComboParamsBase
{
    id: number= 0;
    comboType: string = "";
    useEmpty: boolean = false;

    /// <summary>
    /// NullOrEmpty가 아니면 첫 번재 DisplayItem으로 사용
    /// </summary>
    firstValue : string = "";

    /// <summary>
    /// Default value for selection
    /// </summary>
    defValue : string = "";

    /// <summary>
    /// Combo Item에 "ALL"을 첫번째 index에 추가 (for report ui)
    /// </summary>
    addAllItem: boolean = false;

    /// <summary>
    /// Combo Item에 "DETAIL", "SUMMARY"를 첫번째 index에 추가 (for report ui)
    /// </summary>
    addDetailSummarylItem: boolean = false;

    /// <summary>
    /// Combo Item에 "(Unknown)"을 마지막 index에 추가 (for report ui)
    /// </summary>
    addUnknownItem: boolean = false;

    constructor(init?:Partial<ComboParamsBase>)
    {
      if(init) {
        Object.assign(this, init);
      }
    }
}

export class LookupParamasBase extends ComboParamsBase{
  displayMember: string = "";
  valueMember: string = "";
  listMember: string = "";

  constructor(init?:Partial<LookupParamasBase>)
    {
      super();

      if(init) {
        Object.assign(this, init);
      }
    }
}

/**
 * For Wh Receiving/Shipping
 */
export class WebCenterParams extends ComboParamsBase{
  centerType: string = "";
  
  constructor(init?:Partial<WebCenterParams>)
    {
      super();
      this.comboType = FmsComboType.WebCenter;

      if(init) {
        Object.assign(this, init);
      }
    }
}

/**
 * For Wh Receiving/Shipping
 */
export class EdiWebCenterParams extends ComboParamsBase{
  constructor(init?:Partial<EdiWebCenterParams>)
    {
      super();
      this.comboType = FmsComboType.EdiWebCenter;

      if(init) {
        Object.assign(this, init);
      }
    }
}

/**
 * For Other Shipment Category
 */
export class CategoryParams extends ComboParamsBase{
  constructor()
  {
    super();
    this.comboType = FmsComboType.Category;
  }
}


/**
 * For CreditCard
 */
export class CreditCardParams extends ComboParamsBase{
  inclInactive: boolean = false;
  constructor(init: Partial<CreditCardParams>)
  {
    super(init);
    this.comboType = FmsComboType.CreditCard;

    if(init) {
      Object.assign(this, init);
    }
  }
}

/**
 * For EPay
 */
export class EPayParams extends ComboParamsBase {
  inclInactive: boolean = false;

  constructor(init: Partial<EPayParams>)
  {
    super(init);
    this.comboType = FmsComboType.CodeEPay;

    if(init) {
      Object.assign(this, init);
    }
  }
}

/**
 * For Salesperson
 */
export class SalespersonParams extends ComboParamsBase {
  inclInactive: boolean = false;

  constructor(init: Partial<SalespersonParams>)
  {
    super(init);
    this.comboType = FmsComboType.Salesperson;

    if(init) {
      Object.assign(this, init);
    }
  }
}

/**
 * For Bank
 */
export class BankParams extends ComboParamsBase {
  ignoreNoBranchShow: boolean = false;

  constructor(init?: Partial<BankParams>) {
    super(init);
    this.comboType = FmsComboType.Bank;

    Object.assign(this, init);
  }
}

/**
 * For SecurityGroup
 */
 export class SecurityGroup extends ComboParamsBase{
  constructor()
  {
    super();
    this.comboType = FmsComboType.SecurityGroup;
  }
}

/**
 * For ANTitle
 */
export class ANTitle extends ComboParamsBase{
  IsOcean: boolean = false;
  constructor(init: Partial<ANTitle>)
  {
    super(init);
    this.comboType = FmsComboType.ANTitle;
    if(init) {
      Object.assign(this, init);
    }
  }
}

/**
 * For Company Multi Name
 */
export class MultiName extends ComboParamsBase{
  constructor()
  {
    super();
    this.comboType = FmsComboType.MultiName;
  }
}

/**
 * For Vessel Flag
 */
export class IsoCountryParams extends ComboParamsBase{
  constructor()
  {
    super();
    this.comboType = FmsComboType.IsoCountry;
  }
}

/**
 * For Export License
 */
export class ExportLicense extends ComboParamsBase{
  constructor()
  {
    super();
    this.comboType = FmsComboType.ExportLic;
  }
}

/**
 * For Odtc Category
 */
export class OdtcCategory extends ComboParamsBase{
  constructor()
  {
    super();
    this.comboType = FmsComboType.ODTCCategory;
  }
}

/**
 * For Odtc Unit of measure
 */
export class OdtcUnitOfMeasure extends ComboParamsBase{
  constructor()
  {
    super();
    this.comboType = FmsComboType.ODTCUnitOfMeasure;
  }
}

/**
 * For Export Info
 */
export class ExportInfo extends ComboParamsBase{
  constructor()
  {
    super();
    this.comboType = FmsComboType.ExportInfo;
  }
}

/**
 * For UserDropdown
 */
export class UserParams extends ComboParamsBase {
  hasSubscriberId: boolean = false;
  userEditable : boolean = false;
  inclInactive: boolean = false;

  constructor(init?: Partial<UserParams>) {
    super();
    this.comboType = FmsComboType.User;
    if (init) {
      Object.assign(this, init);
    }
  }
}

/**
 * For Salesperson
 */
export class CustSvcRepParams extends ComboParamsBase {
  inclInactive: boolean = false;

  constructor(init: Partial<CustSvcRepParams>)
  {
    super(init);
    this.comboType = FmsComboType.CustSvcRep;

    if(init) {
      Object.assign(this, init);
    }
  }
}

export enum FmsAutoNumberType
    {
        CrDbNo = "FMSCRDBN",
        OIRefNo = "FMSOIREF",
        OERefNo = "FMSOEREF",
        OEHblNo = "FMSOEHBL",
        OEBookNo = "FMSOEBOK",
        OceanQuoteNo = "FMSOQUOT",
        AIRefNo = "FMSAIREF",
        AERefNo = "FMSAEREF",
        OtQuoteNo = "FMSOTQUOT",

        /// <summary>
        /// eAutoAOHawbNo
        /// </summary>
        AEAwbNo = "FMSAEAWB",
        AirQuoteNo = "FMSAQUOT",
        WHRcptNo = "FMSWHRCP",
        TruckLoadNo = "FMSTRKLD",
        OECargoNo = "FMSOECAR",
        OICargoNo = "FMSOICAR",
        AECargoNo = "FMSAECAR",
        AICargoNo = "FMSAICAR",
        InvenRecNo = "FMSINVRC",
        InvenShipNo = "FMSINVSH",
        OtORefNo = "FMSOTREF",
        PayrollRefNo = "FMSPRREF",  //th190625> 추가
        InvoiceNo = "FMSINVNO",  //th190625> 추가
        BillNo = "FMSBILNO",  //th190625> 추가
        GeneralBillNo = "FMSGBILL",  //th190625> 추가

        TaxRtnRefNo = "FMSTXRTN",
        GeneralInvoNo = "FMSGINVO",
        StorageInvoNo = "FMSSTINV",
        DraftPayNo = "FMSDRPAY",

        /// <summary>
        /// pt210220
        /// </summary>
        LotNo = "FMSLOTNO"
    }

export enum ListFilterType{
  /// <summary>
  /// DownloadAll, JrnlAll, TaskMemoAll
  /// </summary>
  All = 0,
  
  /// <summary>
  /// Not used
  /// </summary>
  Draft = 1,

  /// <summary>
  /// Journal List (240904 Not used)
  /// </summary>
  //WithoutCancelReverser = 1,  // Journal list

  /// <summary>
  /// Task/Memo List - My
  /// </summary>
  My = 1,                   // Memo List (DOC_REQUEST)

  /// <summary>
  /// Not used
  /// </summary>
  ExceptDraft = 2,

  /// <summary>
  /// Task/Memo List - TaskAll
  /// </summary>
  TaskAll = 2,

  /// <summary>
  /// Download List
  /// </summary>
  Downloaded = 3,

  /// <summary>
  /// Task/Memo List
  /// </summary>
  TaskPending = 3,

  /// <summary>
  /// Download List - Not Downloaded
  /// </summary>
  Virgin = 4          // Not downloaded
}

/**
 * Enums of Billing Type for Invoice, Bill, CrDb
 */
// export const ChgType = {
//   None: 0,
//   // Sales Part  --------------------
//   Sales: 1,
//   Collect4Agt: 2,
//   ICSales: 3,
//   TransSale: 4,

//   DueFromAgent: 5,
//   OurSales: 6,
//   TheirSales: 7,

//   DutyLoanA: 8,
//   OtherSales: 9,
//   DutyLoanC: 10,

//   // Cost Part  --------------------
//   Cost: 11,

//   Pay4Agt: 12,
//   Cost2Agt: 13,
//   Cost4Transit: 14,

//   DueToAgent: 15,
//   OurCost: 16,
//   TheirCost: 17,

//   DutyLoan2Agent: 18,
//   OtherCost: 19,
//   DutyLoan2Customer: 20,

//   // Sales Part  --------------------
//   SalesPSOnly: 27,               // DS, IDS - Our Sales (PS Only)  '' <chuck date = "2019-06-04" />

//   // Cost Part  --------------------
//   CostPSOnly: 37,                // DS, IDS - Our Sales (PS Only)  '' <chuck date = "2019-06-04" />
//   DutyPay4Customer: 40           // DS, IDS - Duty pay for Customer  Used in Export Cost   '' <chuck CrDbJournal date = "2017-12-19" />
// };


export enum FmsSecTask{
  // Home
  // Business Intelligence
  BusinessIntelligence = "ACCT_BusinessIntelligence",
  
  // Crm
  Crm = "CRM",

  // Pims
  // PimsOrder = "PIMS_Order",
  // PimsPartnerLogin = "PIMS_PartnerLogin",

  // Ocean Import
  OIMbl = "OI_MBL",
  OIHbl = "OI_HBL",
  OIQuot = "OI_Quotation",
  OITruckLoad = "OI_TruckLoadPlan",
  OIContainer = "OI_ContainerInfo",
  // OIMMyPims = "OI_Shipment_DownloadMyMBL",  // removed
  // OIHMyPims = "OI_Shipment_DownloadMyHBL",  // removed
  OIMPims = "OI_Shipment_DownloadAllMBL",
  OIHPims = "OI_Shipment_DownloadAllHBL",
  // OISoPims = "OI_Shipment_ShippingOrder",  // removed
  OIVessel = "OI_VesselInfo",
  OICfsEdiTo = "OI_CFSEDI_To",
  OICfsEdiFrom = "OI_CFSEDI_From",
  OIRptShipment = "OI_Report_OIShipment",
  OIRptInlandTransport = "OI_Report_InlandTransportation",
  OIRptANLog = "OI_Report_ArrivalNoticeLog",
  OIRptPendingCargo = "OI_Report_PendingCargo",
  OIRptRlsHistory = "OI_Report_ReleaseHistory",
  OIAgentEdi = "OI_BLFromPartner",
  OIDeleteHistory = "OI_DeleteHistory",
  OIRecogHistory = "OI_RecogHistory",

  // Ocean Export
  OEMbl = "OE_MBL",
  OEHbl = "OE_HBL",
  OEBook = "OE_Booking",
  OELoad = "OE_LoadPlan",
  OEQuot = "OE_Quotation",
  OEContainer = "OE_ContainerInfo",
  // OEMMyPims = "OE_Shipment_DownloadMyMBL",  // removed
  // OEHMyPims = "OE_Shipment_DownloadMyHBL",
  OEMPims = "OE_Shipment_DownloadAllMBL",
  OEHPims = "OE_Shipment_DownloadAllHBL",
  // OESoPims = "OE_Shipment_ShippingOrder",  // removed
  OERptShipment = "OE_Report_OEShipment",
  OERptBrokerage = "OE_Report_Brokerage",
  //OECBook = "OE_CarrierBooking",
  OEJapanEdi = "OE_ImportNACCSEDIFile",
  OEDeleteHistory = "OE_DeleteHistory",
  OERecogHistory = "OE_RecogHistory",

  // Air Import
  AIMbl = "AI_MAWB",
  AIHbl = "AI_HAWB",
  AIQuot = "AI_Quotation",
  // AIMMyPims = "AI_Shipment_DownloadMyMAWB",  // removed
  // AIHMyPims = "AI_Shipment_DownloadMyHAWB",  // removed
  AIMPims = "AI_Shipment_DownloadAllMAWB",
  AIHPims = "AI_Shipment_DownloadAllHAWB",
  // AISoPims = "AI_Shipment_ShippingOrder",  // removed
  AIRptPreAlert = "AI_Report_PreAlert",
  AIRptEstProfit = "AI_EstProfitReport", // removed
  AIAgentEdi = "AI_BLFromPartner",
  AIDeleteHistory = "AI_DeleteHistory",
  AIRecogHistory = "AI_RecogHistory",

  // Air Export
  AEMbl = "AE_MAWB",
  AEHbl = "AE_HAWB",
  AEQuot = "AE_Quotation",
  // AEMMyPims = "AE_Shipment_DownloadMyMAWB",  // removed
  // AEHMyPims = "AE_Shipment_DownloadMyHAWB",  // removed
  AEMPims = "AE_Shipment_DownloadAllMAWB",
  AEHPims = "AE_Shipment_DownloadAllHAWB",
  // AESoPims = "AE_Shipment_ShippingOrder",
  AERptEstProfit = "AE_EstProfitReport", // removed
  //AEeAirWayBill = "AE_eAWB",
  AEDeleteHistory = "AE_DeleteHistory",
  AERecogHistory = "AE_RecogHistory",

  // Other Shipment
  OtherOP = "OT_OtherShipment",
  OTQuot = "OT_Quotation",
  OtDeleteHistory = "OT_DeleteHistory",
  OtRecogHistory = "OT_RecogHistory",

  // W/H Receipts
  WHRcpt = "WHReceipts",

  // AMS
  AMSAMSFiling = "AMS_AMSFiling",
  AMSSwitchToAci = "AMS_SwitchToACI",
  AMSVoyage = "AMS_Voyage",
  AMSMaster = "AMS_MBL",
  AMSHouse = "AMS_HBL",
  AMSUser = "AMS_Users",
  AMSBranch = "AMS_Branch",
  //AMSGroup = "AMS_Groups",
  AMSBilling = "AMS_BillingCode",
  AMSHistory = "AMS_History",
  AMSC1History = "AMS_CustomsReleaseHistory",
  AMSRptUsage = "AMS_AMSUsageReport",
  AMSRptContainerTrack = "AMS_CntrTrackingUsageReport",
  AMSRptLifting = "AMS_LiftingReport",
  AMSRptTotalLifting = "AMS_TotalAMSLifting",

  // ACI eManifset
  ACIACIFiling = "ACI_ACIFiling",
  ACIManifest = "ACI_Manifest",
  ACIUsageReport = "ACI_AciUsageReport",


  // ISF
  ISF = "ISF_ISF",

  // Warehousing
  WHRcv = "WH_Receiving",
  WHShip = "WH_Shipping",
  WHInvenSummary = "WH_Inventory_Summary",
  WHInvenDetail = "WH_Inventory_Detail",
  WHStorageInv = "WH_StorageInvoice",
  WHInvoice = "WH_Invoice",
  WHBill = "WH_Bill",
  WHCrDb = "WH_CrDb",
  WHRptChargeItemSummary = "WH_Report_ChargeableItemSummary",
  WHRptCustomerInNOut = "WH_Report_CustomerInNOut",
  WHCustomer = "WH_Setting_Customer",
  WHItem = "WH_Setting_Item",
  WHLoc = "WH_Setting_Location",		

  //In-bond
  Inbond = "Inbond",

  // Accounting
  AcctDashboard = "ACCT_Dashboard",
  AcctSlipJournalList = "ACCT_Journal_JournalLedger",
  //AcctSlipJournal = "ACCT_Journal_AdjustJournalEntry", // removed
  //AcctTransferToAcct2000 = "ACCT_Journal_TransferToAccount2000", // removed
  AcctSearchJournal = "ACCT_Journal_SearchJournal",
  AcctVatAP = "ACCT_Journal_VatAP",       // 한국회계 > VatARAP Report
  AcctVatAR = "ACCT_Journal_VatAR",       // 한국회계 > VatARAP Report
  AcctAging = "ACCT_Aging",
  AcctAgingAR = "ACCT_Aging_AR", // removed
  AcctAgingAP = "ACCT_Aging_AP", // removed
  AcctAgingAgent = "ACCT_Aging_Agent", // removed
  AcctAgingARAP = "ACCT_Aging_ARAP", // removed
  AcctAgingOther = "ACCT_Aging_Other", // removed
  AcctAllPayment = "ACCT_Payment_All",
  AcctCustPayment = "ACCT_Payment_Customer",
  AcctAgntPayment = "ACCT_Payment_Agent",
  AcctBillPayment = "ACCT_Payment_Bill",
  AcctCCPayment = "ACCT_Payment_CreditCard",
  AcctPaymentPrep = "ACCT_Payment_PaymentRequest", // 사용 안 하는 메뉴
  AcctDeposit = "ACCT_BankTransaction_Deposit",
  AcctDepositClear = "ACCT_BankTransaction_Deposit_Clear",
  AcctUndoDeposit = "ACCT_BankTransaction_UndoDeposit",
  AcctUndoDepositClear = "ACCT_BankTransaction_UndoDeposit_Clear",
  AcctCCClear = "ACCT_BankTransaction_CreditCardClear",
  AcctCancelCCClear = "ACCT_BankTransaction_CancelCreditCardClear",
  AcctChkClearWithExcel = "ACCT_BankTransaction_CheckClearWithExcel",
  AcctBankTransfer = "ACCT_BankTransaction_BankTransfer",
  //AcctBankBalRec = "ACCT_BankTransaction_BankBalanceBankRec", // removed
  //AcctBankRecActivity = "ACCT_BankTransaction_BankRecActivityList",
  AcctBankBalance = "ACCT_BankBalance",
  AcctBankRecon = "ACCT_BankRecon",
  AcctGInvoList = "ACCT_GInvBill_GeneralInvoiceList",
  //AcctGInvo = "ACCT_GInvBill_GeneralInvoiceEntry", // removed
  AcctGBillList = "ACCT_GInvBill_GeneralBillList",
  //AcctGBill = "ACCT_GInvBill_GeneralBillEntry", // removed
  AcctCustPaymentMemo = "ACCT_CustomerPaymentMemo",
  AcctDailyAcctSummary = "ACCT_DailyAccountingSummary",
  AcctBalByEntity = "ACCT_AccountBalanceByEntity",
  AcctLedger = "ACCT_AccountLedger",
  //AcctLedgerByEntity = "ACCT_AccountLedgerByEntity", // removed
  AcctGeneralLedger = "ACCT_GeneralLedger",
  AcctIncomeStatement = "ACCT_FinancialReport_IncomeStatement",
  AcctBalanceSheet = "ACCT_FinancialReport_BalanceSheet",
  AcctTrialBalance = "ACCT_FinancialReport_TrialBalance",
  AcctCustStatement = "ACCT_Statement_Customer",
  AcctAgentStatement = "ACCT_Statement_Agent",
  AcctInvoiceList = "ACCT_InvBillCrDb_InvoiceList",
  AcctBillList = "ACCT_InvBillCrDb_BillList",
  AcctCrDbList = "ACCT_InvBillCrDb_CrDbNoteList",
  AcctEmClaimList = "ACCT_iXpense_ClaimList",
  //AcctEmClaim = "ACCT_iXpense_ClaimEntry",  // removed
  AcctPayroll = "ACCT_Payroll",
  //AcctAdjustment = "ACCT_Adjustment", // removed
  AcctPrepaidAdjustment = "ACCT_PrepaidAdjustment",
  AcctDepreciationAdjustment = "ACCT_DepreciationAdjustment",
  AcctAmortizationAdjustment = "ACCT_AmortizationAdjustment",
  AcctBadDebtExpense = "ACCT_BadDeptExpenseProcessing",
  AcctSalesTaxReturnList = "ACCT_SalesTaxReturn_List",
  AcctDistributionPayable = "ACCT_DistributionPayable",
  //AcctSalesTaxReturn = "ACCT_SalesTaxReturn_Entry", // removed
  AcctPeriodClosing = "ACCT_Closing_PeiodClosing",
  AcctEndYearProc = "ACCT_Closing_YearEndProcessing",
  AcctDeleteHistory = "ACCT_DeleteHistory",
  AcctAllPayDeleteHistory = "ACCT_AllPay_DeleteHistory",
  AcctCPayDeleteHistory = "ACCT_CPay_DeleteHistory",
  AcctBPayDeleteHistory = "ACCT_BPay_DeleteHistory",
  AcctCCPayDeleteHistory = "ACCT_CCPay_DeleteHistory",
  AcctAPayDeleteHistory = "ACCT_APay_DeleteHistory",

  // Sales/Cost Recognition		
  SCRecogDeferred = "SalesCostRecog_DeferredReport",
  SCRecogBatchRecog = "SalesCostRecog_BatchRecog",
  SCRecogBatchRecogHistory= "SalesCostRecog_BatchRecogHistory",
  // OP Report
  OPRptEstProfit = "OP_EstProfitReport", // removed
  OPRptRecogProfit = "OP_RecogProfitReport",
  OPRptVendorCost = "OP_VendorCostReport",
  OPRptExpense = "OP_ExpenseReport",
  OPRptVolume = "OP_VolumeReport",
  OPRptProfitBySalesman = "OP_ProfitBySalesman",
  OPRptDutyPendings = "OP_DutyPendings",
  OPRptDutyReport = "OP_DutyReport",
  OPRptIssueReady = "OP_IssueReadyList",
  OPRptSpecial = "OP_SpecailReport_Customize",
  OPRptOpPerfom = "OP_OPPerformanceReport",
  OPRptBranchPerform = "OP_BranchPerformanceReport",
  OPRptProfitByBillCode = "OP_ProfitByBillCodeReport",

  // OP Assist
  OPRptCustomerActivity = "OP_CustomerActivityReport",

  // Codes
  CodeCompany = "Code_Company",
  CodeBranch = "Code_Branch",
  //CodeBroker = "Code_Broker",
  CodeUser = "SYS_CompanyUser",
  CodeGroup = "Code_GroupCode", // 사용 안 하는 메뉴
  CodeLine = "Code_LineCode",
  CodeOtherOPType = "Code_OtherShipmentCategory",
  CodeSalesperson = "Code_Salesman",
  CodeAccountCode = "Code_AccountCode",
  CodeAccountSubCode = "Code_AccountSubCode",
  CodeAutoBillingCharge = "Code_AutoBillingCharge",
  CodeBank = "Code_BankSetup",
  CodeBillingCode = "Code_BillingCode",
  CodeBillingTemplate = "Code_BillingTemplate",
  CodeCfsBillingCharge = "Code_CFSBillingCharge",
  CodeCreditCard = "Code_CreditCardSetup",
  CodeCurrency = "Code_CurrencyCode",
  CodeExchangeRate = "Code_ExchangeRate",
  CodeAirLine = "Code_AirlineCode",
  CodeAirPort = "Code_AirportCode",
  CodeAirRate = "Code_AirRate", // 메뉴가 안 보이게 주석 처리됨
  CodeANTitle = "Code_ArrivalNoticeTitle",
  CodeBLType = "Code_BLTypes",
  CodeCommodity = "Code_CommodityCode", // 사용 안 하는 메뉴
  CodeContainerType = "Code_ContainerType",
  CodeMemoTitle = "Code_MemoTitle",
  CodeMoveType = "Code_MoveType",
  CodeOceanPort = "Code_PortCodeSchedulDandK",
  CodeVessel = "Code_VesselName",
  CodeCountry = "Code_Country",
  CodeEDI315Code = "Code_EDI315Code",
  CodeExportInfo = "Code_ExportInformationCode",
  CodeExportLic = "Code_ExportLicenseCode",
  // CodePimsCustomer = "Code_iPimsCustomerList",
  // CodePimsUser = "Code_iPimsUserList",
  CodeScheduleB = "Code_ScheduleB",
  CodeState = "Code_State",
  CodeScac = "Code_SCACCode",
  CodeUNLocation = "Code_UNLocationCode",
  CodeEPay = "Code_EPay",

  // Utility
  UTAttachedFile = "UT_AttachedFileList",
  UTCmpAddrPrint = "UT_CompanyAddressLabelPrinting",
  UTEmailLog = "UT_EmailLog",
  UTFaxLog = "UT_FaxLog",
  UTPrintLog = "UT_PringLog",
  UTMergePort = "UT_MergePortCode",
  UTTaskMemoList = "UT_TaskMemoList",
  //UTUserSecurity = "UT_UserSecurity",
  UTUserSecurity = "SYS_UserSecurity",
  UTCommunication = "UT_Communication",
  //UTEmailTemplate = "UT_EmailTemplate",

  // Tool
  ToolMemo = "Tool_Memo",
  ToolBlock = "Tool_Block",
  ToolCancelBlock = "Tool_CancelBlock",
  ToolOpClose = "Tool_OPClose",
  ToolCancelOpClose = "Tool_CancelOPClose",
  ToolAccountClose = "Tool_AccountClose",
  ToolCancelAccountClose = "Tool_CancelAccountClose",
  ToolRecog = "Tool_Recognize",
  ToolCancelRecog = "Tool_CancelRecognize",
  ToolExportToExcel = "Tool_ExportToExcel",

  // Setup
  SystemSetup = "SYS_SystemSettings",
  SubscriberMgr = "SYS_SubscriberMgr",
  CompanyProfile = "SYS_CompanyProfile",
  Payroll = "SYS_Payroll",

  // Home
  HomeAgentOutstanding = "AGBR",
  HomeCustOutstanding = "CUBR",
  HomeVendOutstanding = "VEBR",
  HomeTotalSalesReview = "ESPR",

  // MyEvent
  MyEvent = "MyEvent",

  TaskListLoginUser = "Task_LoginUser", //not used
  TaskListAll = "Task_All",
  TaskList = "Task_TaskList",

  ListJournalOP = "ListJournalOP",
  ListJournalBillings = "ListJournalBillings",
  ListJournalPayment = "ListJournalPayment",
  ListBalance = "ListBalance", // ListVIew > Balance 버튼 및 Detail 내 Balance도 컨트롤

  AllContainer = "All_ContainerInfo",
  //Shipment Status
  RptCustomerShipment = "RptCustomerShipment",
  AES = "AES",
  AICenter = "AICenter",
}


//AMS에 권한이 있는 Security 선언
export const FmsSecAmsTasks = [
  FmsSecTask.AMSRptUsage,
  FmsSecTask.AMSRptLifting ,
  FmsSecTask.AMSRptTotalLifting ,
  FmsSecTask.AMSVoyage ,
  FmsSecTask.AMSMaster ,
  FmsSecTask. AMSHouse,
  FmsSecTask.AMSUser ,
  FmsSecTask.AMSBranch,
  FmsSecTask.AMSBilling,
  FmsSecTask.AMSHistory,
  FmsSecTask.AMSC1History,
]

